import React from "react";

import { Container } from "@components/Container/Container";
import styles from "./styles.module.scss";
import { Heading } from "@components/Heading/Heading";
import { Text } from "@components/Text/Text";
import { Link } from "@components/Link/Link";
import Anime from "react-anime";
import { animeChildrenProps } from "@helpers/animations";
import { useInView } from "react-intersection-observer";

interface Properties {
  Name: string;
  Value: string;
  ValueMarkup: string;
}

interface searchDocument {
  Id: number;
  FriendlyUri: string;
  Properties: Properties[];
}

interface searchResult {
  SearchId: string;
  Offset: number;
  Documents: searchDocument[];
}

export interface SearchPageProps {
  searchresults: searchResult;
  query?: string;
  ankiroSearchID: string;
  ankiroDocumentOffset: number;
}

const SearchPage: React.FC<SearchPageProps> = ({
  searchresults,
  query,
  ankiroDocumentOffset
}) => {
  const { ref, inView } = useInView({
    threshold: 0.2
  });
  const animateEachChild = {
    ...animeChildrenProps,
    ...(inView ? { autoplay: true } : { autoplay: false })
  };

  const clickEvent = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    id: number
  ) => {
    event.preventDefault();
    const url = event.currentTarget.href;
    fetch(
      `//sikkertrafik.ankiro.dk/Public/Rest/Redir?url=${url}&searchId=${searchresults.SearchId}&documentId=${id}&documentOffset=${searchresults.Offset}`,
      { method: "get" }
    )
      .then(function() {
        globalThis.window.location = url;
      })
      .catch(function() {
        globalThis.window.location = url;
      });
  };

  return (
    <div ref={ref}>
      <Container variant="large">
        {query && <Heading as="h2">Søgeord: {query}</Heading>}

        <Anime {...animateEachChild}>
          {searchresults.Documents && searchresults.Documents.length ? (
            searchresults.Documents.map(
              (document: searchDocument, index: number) => {
                const title = document.Properties.find(x => x.Name === "Title");
                let description = document.Properties.find(
                  x => x.Name === "Content"
                );
                if (!description) {
                  description = document.Properties.find(
                    x => x.Name === "Description"
                  );
                }
                return (
                  <Link
                    key={`searchresult-${index}`}
                    href={document.FriendlyUri}
                    className={styles.result}
                    onClick={e => clickEvent(e, document.Id)}
                  >
                    <Text className={styles.title}>{title?.Value}</Text>
                    {description && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: description?.ValueMarkup
                        }}
                      ></div>
                    )}
                  </Link>
                );
              }
            )
          ) : (
            <Text>Ingen resultater</Text>
          )}
        </Anime>
      </Container>
    </div>
  );
};

export { SearchPage };
